module.exports = __webpack_public_path__ + "img/icon-facebook.09ac26b0.svg";